var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListingPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7949,6.5051 L7.4949,0.2051 C7.2212,-0.0686 6.7788,-0.0686 6.5051,0.2051 L0.2051,6.5051 C0.0049,6.7053 -0.0553,7.0063 0.0532,7.2681 C0.161,7.5299 0.4172,7.7 0.7,7.7 L1.4,7.7 L1.4,14 L12.6,14 L12.6,7.7 L13.3,7.7 C13.5828,7.7 13.839,7.5299 13.9468,7.2681 C14.0553,7.0063 13.9944,6.7053 13.7949,6.5051 Z M9.1,7.7 L6.65,7.7 C6.4568,7.7 6.3,7.8568 6.3,8.05 C6.3,8.2432 6.4568,8.4 6.65,8.4 L7.35,8.4 C8.3146,8.4 9.1,9.1854 9.1,10.15 C9.1,10.9942 8.498,11.7019 7.7,11.865 L7.7,12.6 L6.3,12.6 L6.3,11.9 L4.9,11.9 L4.9,10.5 L7.35,10.5 C7.5432,10.5 7.7,10.3432 7.7,10.15 C7.7,9.9568 7.5432,9.8 7.35,9.8 L6.65,9.8 C5.6854,9.8 4.9,9.0146 4.9,8.05 C4.9,7.2051 5.502,6.4981 6.3,6.3357 L6.3,5.6 L7.7,5.6 L7.7,6.3 L9.1,6.3 L9.1,7.7 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingPrice);
export default __webpack_public_path__ + "static/media/listing-price.81f45acdb8ef44ad0875082635609213.svg";
export { ForwardRef as ReactComponent };